import _ from 'lodash';

export default function getPickUpPointsAndRecipientsFromOrders(orders) {
  let pickUpPoints = [];
  let recipients = [];

  _.map(orders, (order) => {
    if(order.recipient)
      recipients.push(order.recipient);

    _.map(order.items, (item) => {
      if(item.pickUpPoint)
        pickUpPoints.push(item.pickUpPoint);
    });
  });

  return {pickUpPoints: _.uniqBy(pickUpPoints, 'id'), recipients};
}



// WEBPACK FOOTER //
// ./src/businessLogic/getRecipientsAndPointsFromOrders.js